import { Routes } from '@angular/router';
import { Constants } from '@app/constants';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { AgentSummariesContainerComponent } from './summaries-container.component';
import { SummariesReportComponent } from './summaries-reports/summaries-reports.component';
import { AgentSummariesReportComponent } from './agent-summaries-report/agent-summaries-reports.component';
import { AgentCallEvaluationFormApprovalListComponent } from '../agent-calls-evaluation/agent-call-evaluation-form-approval-list/agent-call-evaluation-form-approval-list.component';

export const summariesReports = [
  {
    "name": "Call Details",
    "route": "call-details",
    "module": "summaries",
    "icon": "fa fa-phone-alt",
  },
  {
    "name": "Sales Report",
    "route": "sales-report",
    "module": "summaries",
    "icon": "fa fa-dollar",
  },
  {
      "name": "Daily Summary",
      "route": "daily-summary",
      "module": "summaries",
      "icon": "fa fa-chart-line",
  },
  {
    "name": "Agents Acitvity",
    "route": "agents-acitvity",
    "module": "summaries",
    "icon": "fa fa-user-check",
  },
  {
    "name": "TFN Summary",
    "route": "tfn-wise-summary",
    "module": "summaries",
    "icon": "fa fa-list",
  },
  {
    "name": "Agent Summary",
    "route": "agent-wise-summary",
    "module": "summaries",
    "icon": "fa fa-user-circle",
  },
  {
    "name": "Agent Dispositions",
    "route": "agent-wise-dispositions",
    "module": "summaries",
    "icon": "fa fa-file-signature",
  },
  {
    "name": "Skill Summary",
    "route": "skill-wise-summary",
    "module": "summaries",
    "icon": "fa fa-compress",
  } 
]

export const agentSummariesReports = [
  {
    "name": "Callback",
    "route": "callback",
    "module": "summaries",
    "icon": "fa fa-phone-alt",
  },
  {
    "name": "Call Logs",
    "route": "callLog",
    "module": "summaries",
    "icon": "fa fa-clock-rotate-left",
  },
  {
    "name": "Leads",
    "route": "leads",
    "module": "summaries",
    "icon": "fa fa-dollar",
  },
  {
      "name": "Meeting Schedular",
      "route": "lead-schedular",
      "module": "summaries",
      "icon": "fa fa-chart-line",
  },
  {
    "name": "My Calls",
    "route": "my-calls",
    "module": "summaries",
    "icon": "fa fa-user-check",
  },
  {
    "name": "My Sales",
    "route": "my-sales",
    "module": "summaries",
    "icon": "fa fa-list",
  }
]

export const routes: Routes = [
  {
    path: '',
    component: AgentSummariesContainerComponent,
    data: {
      permissions: { only: 'insights_dashboard', redirectTo: '/page-not-found' },
    },
    children: summariesReports.map((report) => {
      return {
        path: report.route,
        canActivate: [NgxPermissionsGuard],
        component: SummariesReportComponent,
        pathMatch: 'full',
        data: {
          permissions: { only:'insights_dashboard', redirectTo: '/page-not-found' },
          app: Constants.Apps.Agent,
          title: report.name,
        },
      };
    })
  },
  {
    path: '',
    component: AgentSummariesContainerComponent,
    data: {
      permissions: { only: ["agent_dashboard", "agent_calls", "agent_statistics"], redirectTo: '/page-not-found' },
    },
    children: agentSummariesReports.map((report) => {
      return {
        path: report.route,
        canActivate: [NgxPermissionsGuard],
        component: AgentSummariesReportComponent,
        pathMatch: 'full',
        data: {
          permissions: { only: ["agent_dashboard", "agent_calls", "agent_statistics"], redirectTo: '/page-not-found' },
          app: Constants.Apps.Agent,
          title: report.name,
        },
      };
    })
  }
];
